import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './WhyDiveWithPadiCard.module.scss'

IconBenefit.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  termsLink: PropTypes.string,
}

export default function IconBenefit({ icon, title, description, termsLink }) {
  return (
    <div className={styles.benefit}>
      <div className={styles.benefitHeader}>
        <span className={styles.benefitIcon}>{icon}</span>
        <span className={styles.benefitTitle}>{title}</span>
      </div>
      <p className={styles.benefitDesc}>{description}</p>
      {termsLink && (
        <a
          href={termsLink}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.termsLink}
        >
          <FormattedMessage id='see_terms_and_conditions' defaultMessage='See Terms and Conditions' />
        </a>
      )}
    </div>
  )
}
